import React from 'react';
import { Header, BackgroundTest, FeaturesSection, AIResourcesSection, PlatformSection, TestimonialsSection, IntegrationsSection, WhyNowSection, ProofSecuritySection, PricingSection, FAQsSection, CTASection, Footer } from '../components';
import HeroShowcase from '../components/Hero/HeroShowcase';

const Home: React.FC = () => {
  return (
    <div className="home">
      <Header />
      <BackgroundTest />
      {/* <HeroShowcase />     ⬅️ pílulas + micro-demo descem para aqui */}
      <FeaturesSection />
      <PlatformSection />
      {/* <AIResourcesSection /> */}
      <TestimonialsSection />
      <IntegrationsSection />
      <WhyNowSection />
      <ProofSecuritySection />
      {/* <PricingSection /> */}
      {/* <FAQsSection /> */}
      <CTASection />
      {/* <HeroShowcase /> */}
      <Footer />
    </div>
  );
};

export default Home;
